<template>
  <div :class="['participation-icon', getStatusClass]">
    <CheckOutlined v-if="status === PARTICIPATION_STATUS.PARTICIPATING" />
    <CloseOutlined v-else-if="status === PARTICIPATION_STATUS.NOT_PARTICIPATING" />
    <QuestionOutlined v-else />
  </div>
</template>

<script>
import { CheckOutlined, CloseOutlined, QuestionOutlined } from '@ant-design/icons-vue';
import { PARTICIPATION_STATUS } from '../constants/participation';

export default {
  name: 'ParticipationIcon',
  components: {
    CheckOutlined,
    CloseOutlined,
    QuestionOutlined
  },
  props: {
    status: {
      type: Number,
      default: PARTICIPATION_STATUS.NO_STATUS
    }
  },
  setup() {
    return {
      PARTICIPATION_STATUS // Make it available in template
    };
  },
  computed: {
    getStatusClass() {
      switch (this.status) {
        case PARTICIPATION_STATUS.PARTICIPATING:
          return 'participating';
        case PARTICIPATION_STATUS.NOT_PARTICIPATING:
          return 'not-participating';
        case PARTICIPATION_STATUS.NO_STATUS:
        default:
          return 'unknown';
      }
    }
  }
};
</script>

<style scoped>
.participation-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: var(--border-radius-circle);
  margin-right: var(--spacing-sm);
}

.participating {
  background-color: var(--color-success);
  color: white;
}

.not-participating {
  background-color: var(--color-error);
  color: white;
}

.unknown {
  background-color: var(--color-border-secondary);
  color: white;
}
</style>